import type { FileApprovalProgress } from '../model/types';
import { i18n } from '@/shared/i18n';

export type FileApprovalState = 'not_started' | 'in_progress' | 'completed';

export function getFileApprovalState(progress: FileApprovalProgress): FileApprovalState {
  if (progress.status === 'completed') return 'completed';
  if (progress.status === 'not_started') return 'not_started';
  return 'in_progress';
}

export function getFileApprovalLabel(progress: FileApprovalProgress): string {
  if (getFileApprovalState(progress) === 'completed')
    return i18n.t('common:ui.approvalActionButton.approved');

  return i18n.t('projects:assetApprovalChain.fileProgressUtils.stepsApproved', {
    approved: progress.approvedStepCount,
    total: progress.totalSteps,
  });
}

export function getFileApprovalAwaitingLabel(progress: FileApprovalProgress): string {
  if (getFileApprovalState(progress) === 'completed') return '';
  if (!progress.currentStepName) return '';

  return i18n.t('projects:assetApprovalChain.fileProgressUtils.stepsAwaiting', {
    stepName: progress.currentStepName,
  });
}
